import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  FreteDedicadoListarInconsistenciasRequest,
  FreteDedicadoListarInconsistenciasResponse,
  FreteDedicadoOutput,
  FreteDedicadoUploadExcelRequest,
  FreteDedicadoUploadExcelResponse,
  RequisicaoFreteDedicado
} from 'src/app/@shared/models/frete-dedicado.model';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

const filtros = (obj: FreteDedicadoListarInconsistenciasRequest | RequisicaoFreteDedicado) => {
  const filtro = Object.entries(obj).filter(([k, v]) => v);
  return new URLSearchParams(filtro);
}

@Injectable({
  providedIn: 'root'
})
export class FreteDedicadoService {

  constructor(private http: HttpClient) { }

  consultaFretesDedicados(obj: RequisicaoFreteDedicado): Observable<FreteDedicadoOutput[]> {
    const filter = `${obj.codigoRoteiro ? `codigoRoteiro=${obj.codigoRoteiro}&` : ''}` +
      `${obj.codigoCliente ? `codigoCliente=${obj.codigoCliente}&` : ''}` +
      `${obj.codigoProduto ? `codigoProduto=${obj.codigoProduto}&` : ''}` +
      `${obj.codigoTipoVeiculo ? `codigoTipoVeiculo=${obj.codigoTipoVeiculo}&` : ''}` +
      `${obj.ativoInativo ? `ativoInativo=${obj.ativoInativo}&` : ''}` +
      `${obj.paginaAtual ? `paginaAtual=${obj.paginaAtual}&` : ''}` +
      `${obj.itensPorPagina ? `itensPorPagina=${obj.itensPorPagina}` : ''}`;
    return this.http.get<FreteDedicadoOutput[]>(
      `FreteDedicado/obtenhaDados?${filter}`,
      httpOptions
    );
  }

  incluirFreteDedicado(obj: any): Observable<any> {
    return this.http.post<any[]>(`FreteDedicado/inclua`, obj, httpOptions);
  }

  atualizarFreteDedicado(obj: any): Observable<any> {
    return this.http.post<any[]>(`FreteDedicado/atualize`, obj, httpOptions);
  }

  uploadExcel(obj: FreteDedicadoUploadExcelRequest): Observable<FreteDedicadoUploadExcelResponse> {
    return this.http.put<FreteDedicadoUploadExcelResponse>(`FreteDedicado/uploadExcel`, obj, httpOptions);
  }

  listarInconsistencias(obj: FreteDedicadoListarInconsistenciasRequest)
    : Observable<FreteDedicadoListarInconsistenciasResponse[]> {
      return this.http.get<FreteDedicadoListarInconsistenciasResponse[]>(
        `FreteDedicado/SelecionarInconsistencias?${filtros(obj)}`,
        httpOptions
      );
    }

    public exportarExcel(obj: RequisicaoFreteDedicado): Observable<any> {
      return this.http.get<any>(`FreteDedicado/exportarExcel?${filtros(obj)}`, httpOptions);
    }

    public downloadTemplate(): Observable<any> {
      return this.http.get<any>(`FreteDedicado/DownloadTemplate`, httpOptions);
    }

}